import { InitialLeftWidthConfig } from './constants';

export type InitialLeftWidthInput = number | Partial<InitialLeftWidthConfig> | null | undefined;

export type ClampLeftWidthParams = {
  leftWidth: number;
  containerWidth: number;
  minLeftWidth: number;
  handleWidth: number;
  minRightWidth: number;
};

export const normalizeInitialLeftWidth = (
  initialLeftWidth: InitialLeftWidthInput
): InitialLeftWidthConfig => {
  if (typeof initialLeftWidth === 'number') {
    return {
      percent: null,
      min: initialLeftWidth,
      max: null
    };
  }

  return {
    percent: initialLeftWidth?.percent ?? 0.4,
    min: initialLeftWidth?.min ?? 400,
    max: initialLeftWidth?.max ?? null
  };
};

export const clampLeftWidth = ({
  leftWidth,
  containerWidth,
  minLeftWidth,
  handleWidth,
  minRightWidth
}: ClampLeftWidthParams): number => {
  const maxLeftWidth = Math.max(0, containerWidth - handleWidth - minRightWidth);
  const effectiveMinLeftWidth = Math.min(minLeftWidth, maxLeftWidth);

  return Math.max(effectiveMinLeftWidth, Math.min(leftWidth, maxLeftWidth));
};

export const getInitialLeftWidth = ({
  containerWidth,
  splitConfig,
  minLeftWidth,
  handleWidth,
  minRightWidth
}: {
  containerWidth: number;
  splitConfig: InitialLeftWidthConfig;
  minLeftWidth: number;
  handleWidth: number;
  minRightWidth: number;
}): number => {
  const percentWidth =
    splitConfig.percent != null ? containerWidth * splitConfig.percent : minLeftWidth;
  const boundedWidth =
    splitConfig.max != null
      ? Math.min(splitConfig.max, Math.max(minLeftWidth, percentWidth))
      : Math.max(minLeftWidth, percentWidth);

  return clampLeftWidth({
    leftWidth: boundedWidth,
    containerWidth,
    minLeftWidth,
    handleWidth,
    minRightWidth
  });
};
